import { axiosV2 } from "config/@axios";
import * as uiActions from "store/actions/uiActions";

import i18next from "i18next";

export const FETCH_DLISTS_PENDING = "Dlists->uiActions::pendingDlists";
export const FETCH_DLISTS_SUCCESS = "Dlists->uiActions::fetchDlistsSuccess";
export const FETCH_DLISTS_FAILED = "Dlists->uiActions::fetchDlistsFailed";
export const GET_DLIST = "Dlists->uiActions::getDlist";

export const FETCH_DLISTS_MEMBERS_SUCCESS =
  "Dlists->uiActions::fetchMembersSuccess";
export const ADD_MEMBER = "Dlists->uiActions::addMember";
export const DELETE_MEMBER = "Dlists->uiActions::deleteMember";
export const DELETE_MEMBER_SUCCESS = "Dlists->uiActions::deleteMemberSuccess";
export const DELETE_MEMBER_FAILED = "Dlists->uiActions::deleteMemberFailed";
export const SET_DELETE_MEMBER_MODAL =
  "Dlists->uiActions::setDeleteMemberModal";
export const CLOSE_MEMBER_DELETE_MODAL =
  "Dlists->uiActions::closeMemberDeleteModal";
export const UPSERT_MEMBER = "Dlists->uiActions::upsertMember";
export const UPSERT_MEMBER_SUCCESS = "Dlists->uiActions::upsertMemberSuccess";
export const UPSERT_MEMBER_FAILED = "Dlists->uiActions::upsertMemberFailed";
export const OPEN_MEMBER_MODAL = "Dlists->uiActions::openMemberModal";
export const CLOSE_MEMBER_MODAL = "Dlists->uiActions::closeMemberModal";

export const UPDATE_MEMBER = "Dlists->uiActions::updateMember";
export const CLEAR_ERROR = "Dlists->uiActions::clearError";

export const SELECT_ALL = "Dlists->uiActions::SelectAll";
export const SELECT_SINGLE = "Dlists->uiActions::SelectSingle";

export const fetchDlists = params => dispatch => {
  dispatch({
    type: FETCH_DLISTS_PENDING
  });
  return axiosV2
    .get("distributionlists", {
      params
    })
    .then(response => {
      const xMore = parseInt(response?.headers?.["x-more"]);
      dispatch({
        type: FETCH_DLISTS_SUCCESS,
        payload: {
          dlists: response.data,
          hasMore: !!xMore,
          params
        }
      });
    })
    .catch(err => {
      dispatch({
        type: FETCH_DLISTS_FAILED,
        payload: err?.errorMessage
      });
    });
};

export const fetchMembers = (dlist, params) => dispatch => {
  dispatch({
    type: FETCH_DLISTS_PENDING
  });
  return axiosV2
    .get(`distributionlists/${dlist}/members`, {
      params
    })
    .then(response => {
      const xMore = parseInt(response?.headers?.["x-more"]);
      dispatch({
        type: FETCH_DLISTS_MEMBERS_SUCCESS,
        payload: {
          members: response.data,
          dlist,
          hasMore: !!xMore,
          params
        }
      });
    })
    .catch(err => {
      dispatch({
        type: FETCH_DLISTS_FAILED,
        payload: err?.errorMessage
      });
    });
};

export const addMember = payload => {
  const data = { ...payload?.[0], timestamp: new Date().getTime() };
  return {
    type: ADD_MEMBER,
    payload: data
  };
};
export const updateMember = payload => {
  return {
    type: UPDATE_MEMBER,
    payload
  };
};

export const deleteMember = (dlist, members) => dispatch => {
  const data = members.map(member => ({
    member
  }));
  return axiosV2
    .post(`/distributionlists/${dlist}/members/_delete`, data)
    .then(() => {
      dispatch({
        type: DELETE_MEMBER_SUCCESS,
        payload: members
      });
      dispatch(
        uiActions.addSnackbar({
          message: i18next.t("contacts:dlists.messages.success_delete")
        })
      );
      dispatch(
        fetchMembers(dlist, {
          start: 0,
          count: 1000
        })
      );
      setDeleteMemberModal({
        deleteMembers: null
      });
    })
    .catch(err => {
      dispatch({
        type: DELETE_MEMBER_FAILED,
        payload: err.errorMessage
      });
    });
};

export const upsertMember = (dlist, data) => dispatch => {
  dispatch({
    type: UPSERT_MEMBER
  });
  return axiosV2
    .post(`distributionlists/${dlist}/members`, [data])
    .then(response => {
      const data = response.data?.[0];
      if (data.status === "failed") {
        dispatch({
          type: UPSERT_MEMBER_FAILED,
          payload: i18next.t(`generic:errors.${data.message}`)
        });
      } else {
        dispatch(
          fetchMembers(dlist, {
            start: 0,
            count: 1000
          })
        );
        dispatch(
          uiActions.addSnackbar({
            message: i18next.t("contacts:dlists.messages.success_message")
          })
        );
        dispatch({
          type: UPSERT_MEMBER_SUCCESS,
          payload: i18next.t(`generic:errors.${data.message}`)
        });
      }
    })
    .catch(err => {
      dispatch({
        type: UPSERT_MEMBER_FAILED,
        payload: err.errorMessage
      });
    });
};

export const getDLIST = id => {
  return {
    type: GET_DLIST,
    payload: id
  };
};
export const setDeleteMemberModal = payload => {
  return {
    type: SET_DELETE_MEMBER_MODAL,
    payload
  };
};
export const closeMemberDeleteModal = payload => {
  return {
    type: CLOSE_MEMBER_DELETE_MODAL,
    payload
  };
};

export const openMemberModal = payload => {
  return {
    type: OPEN_MEMBER_MODAL,
    payload
  };
};
export const closeMemberModal = payload => {
  return {
    type: CLOSE_MEMBER_MODAL,
    payload
  };
};

export const selectAll = isSelected => (dispatch, getState) => {
  const { contacts } = getState();
  let list = Object.values(contacts.dlists.members.byId)
    .filter(item => item.admin !== 1)
    .map(item => item.value);

  dispatch({
    type: SELECT_ALL,
    payload: {
      isSelected,
      list
    }
  });
};

export const selectSingle = (value, isSelected) => ({
  type: SELECT_SINGLE,
  payload: {
    value,
    isSelected
  }
});

export const clearError = () => ({
  type: CLEAR_ERROR
});
